/*
  Ingeniería de Software      = 0
  Ingeniería de Sistemas      = 1
  Arquitectura y Redes        = 2
  Matemáticas                 = 3
  Formación complementaria    = 4

*/

export const career_data = {
    name: "Ingeniería en Sistemas de Información con grado de Bachillerato (BA-INFORM) y salida lateral de Diplomado en Programación de Aplicaciones Informáticas",
    code: "BA-INFORM",
    mesh: {
        "0 0": {
            "#Ingeniería de Software": [
                "Ingeniería de Software",
                [],
                0
            ],
            "#Ingeniería de Sistemas": [
                "Ingeniería de Sistemas",
                [],
                1
            ],
            "#Arquitectura y Redes": [
                "Arquitectura y Redes",
                [],
                2
            ],
            "#Matemáticas": [
                "Matemáticas",
                [],
                3
            ],
            "#Formación complementaria": [
                "Formación complementaria",
                [],
                4
            ]
        },
        "1 1": {
            "EIF200": ["Fundamentos de informática", [], 0],
            "MAT030": ["Matemática para informática", [], 3],
            "LIX410": ["Inglés Integrado I", [], 4],
            "GEN1": ["Estudios Generales I", [], 4],
            "GEN2": ["Estudios Generales II", [], 4]
        },
        "1 2": {
            "EIF201": ["Programación I", ["EIF200", "MAT030"], 0],
            "MAT002": ["Cálculo I", ["MAT030"], 3],
            "LIX411": ["Inglés Integrado II", ["LIX410"], 4],
            "GEN3": ["Estudios Generales III", [], 4],
            "GEN4": ["Estudios Generales IV", [], 4]
        },
        "2 1": {
            "EIF204": ["Programación II", ["EIF201"], 0],
            "MAT005": ["Álgebra lineal", ["MAT002"], 3],
            "EIF202": ["Soporte técnico", ["EIF200"], 2],
            "EIF203": ["Estructuras discretas para informática", ["EIF200", "MAT030"], 0],
            "LIX412": ["Inglés integrado III", ["LIX411"], 4]
        },
        "2 2": {
            "EIF206": ["Programación III", ["EIF204", "MAT002"], 0],
            "EIF207": ["Estructuras de datos", ["EIF203", "EIF204"], 0],
            "EIF205": ["Arquitectura de computadoras", ["EIF201", "EIF202"], 2],
            "EIF404": ["La organización y su entorno", ["EIF201"], 4],
            "MAT006": ["Probabilidad y estadística para la informática", ["MAT002", "EIF203"], 3]
        },
        "3 1": {
            "EIF209": ["Programación IV", ["EIF206"], 0],
            "EIF210": ["Ingeniería de sistemas I", ["EIF206"], 1],
            "EIF211": ["Diseño e implementación de bases de datos", ["EIF206", "EIF207"], 1],
            "EIF212": ["Sistemas operativos", ["EIF204", "EIF205"], 2],
            "EIF208": ["Comunicaciones y redes de computadores", ["EIF205"], 2]
        },
        "3 2": {
            "EIF400": ["Paradigmas de programación", ["EIF206"], 0],
            "EIF401": ["Ingeniería de sistemas II", ["EIF210"], 1],
            "EIF402": ["Administración de bases de datos", ["EIF212", "EIF211"], 1],
            "EIF412": ["Investigación de operaciones y sus aplicaciones", ["EIF206", "MAT005", "MAT006"], 0],
            "EIF407": ["Liderazgo y organización", ["EIF404"], 4]
        },
        "4 1": {
            "EIF411": ["Diseño y programación de plataformas móviles", ["EIF209"], 0],
            "EIF406": ["Ingeniería de sistemas III", ["EIF401"], 1],
            "EIF413": ["Métodos de investigación científica en informática", ["MAT006"], 4],
            "OPT1": ["Optativa", [], 5],
            "OPT2": ["Optativa", [], 5]
        },
        "4 2": {
            "EIF408": ["Proyectos y su aplicación en la organización (PPS)", ["EIF209", "EIF401", "EIF402"], 1],
            "EIF409": ["Aplicaciones informáticas globales", ["EIF209", "EIF401", "EIF402"], 1],
            "EIF410": ["Informática y sociedad", ["EIF401"], 4],
            "OPT3": ["Optativa", [], 5],
            "OPT4": ["Optativa", [], 5]
        },
        "Opt": {
            "EIF100O": ["Dispositivos para comunicaciones de datos", ["EIF208"], 2],
            "EIF420O": ["Inteligencia artificial", ["EIF207"], 2],
            "EIF421O": ["Análisis de algoritmos", ["EIF207", "MAT002"], 0],
            "EIF422O": ["Diseño de interfaces de usuario", ["EIF206"], 0],
            "EIF424O": ["Desarrollo de aplicaciones educativas", ["EIF204", "EIF206"], 0],
            "EIF425O": ["Diseño de ambientes multimediales", ["EIF204", "EIF206"], 0],
            "EIF426O": ["Diseño de ambientes de aprendizaje", ["EIF204", "EIF206"], 0],
            "EIF427O": ["Robótica", ["EIF204"], 2],
            "EIF431O": ["Administración de Servidores Basados en Software libre", ["EIF212", "EIF402"], 2],
            "EIF432O": ["Introducción a la Programación Paralela en Arquitecturas Multinúcleo", ["EIF207", "EIF212"], 2],
            "EIF436O": ["Gráficos por Computadora", ["EIF207", "MAT005"], 0],
            "EIF440O": ["Seguridad Informática", ["EIF208", "EIF212"], 0],
            "EIF441O": ["Soporte Técnico Avanzado", ["EIF202"], 2]
        }
    }
};